import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAF9]">
      <div className="p-6"><Logo /></div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-md bg-white border border-[#E2EBF0] rounded-2xl shadow-sm p-8 text-center" data-testid="payment-cancel-card">
          <XCircle className="h-12 w-12 text-[#4A635A] mx-auto" />
          <h1 className="font-heading font-bold text-2xl text-[#0D3B2D] mt-5">Payment canceled</h1>
          <p className="text-sm text-[#4A635A] mt-2">No charge was made. You can complete the payment anytime from the link you were sent.</p>
          <Button onClick={() => navigate("/")} className="mt-6 w-full bg-[#0D3B2D] text-white rounded-lg py-6">
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
